import React from "react";

/**
 * Reusable Quiet Duotone icon used throughout hub navigation.
 *
 * Visual system:
 * - Soft lavender rounded tile
 * - Lucide icon as the primary visual
 * - Subtle circular halo
 *
 * Usage:
 *
 * <HubIcon icon={Users} />
 *
 * Optional sizes:
 * <HubIcon icon={Users} size="sm" />
 * <HubIcon icon={Users} size="md" />
 * <HubIcon icon={Users} size="lg" />
 */
const HubIcon = ({ icon: Icon, size = "md", className = "" }) => {
  if (!Icon) return null;

  const sizes = {
    sm: {
      container: "w-12 h-12 rounded-[15px]",
      icon: "w-5 h-5",
      halo: "w-7 h-7",
    },

    md: {
      container: "w-[68px] h-[68px] rounded-[19px]",
      icon: "w-[29px] h-[29px]",
      halo: "w-[37px] h-[37px]",
    },

    lg: {
      container: "w-20 h-20 rounded-[22px]",
      icon: "w-8 h-8",
      halo: "w-11 h-11",
    },
  };

  const currentSize = sizes[size] || sizes.md;

  return (
    <div
      aria-hidden="true"
      className={`
        relative
        ${currentSize.container}
        ${className}
        shrink-0
        overflow-hidden
        flex
        items-center
        justify-center
        bg-[#F7F5FC]
      `}
    >
      {/* Soft duotone halo */}
      <span
        className={`
          absolute
          ${currentSize.halo}
          rounded-full
          bg-[#E8E3F6]
          translate-x-2
          -translate-y-2
        `}
      />

      {/* Primary Lucide icon */}
      <Icon
        className={`
          relative
          z-10
          ${currentSize.icon}
          text-[#4B32A8]
        `}
        strokeWidth={1.8}
      />
    </div>
  );
};

export default HubIcon;